<div class="order-detail__container px-0 hand"   (click)="passId(data?.id)">
  <div
    class="p-1 p-sm-2 order-detail__wrapper {{
      chageBgcolor == true ? 'change-bgcolor' : ''
    }}"
    [ngClass]="getclass"
  >
    <div class="d-flex justify-content-between m-r-10">
      <div class="d-flex align-items-center text-truncate gap-3">
        <p class="text-primary-color m-l-10 hand text-truncate secondary-text " ngbTooltip="{{data?.title}}" placement="bottom" position="bottom">
        <!-- style="max-width: 150px" -->
          {{ data?.title ? data?.title : "Call For Order Details" }}
        </p>
        <img
          *ngIf="istrue && iconHide"
          (click)="toogleIcon = !toogleIcon; toggle.emit(toogleIcon)"
          class="m-l-5 hand"
          height="15"
          width="15"
          src="./assets/SVGIcons/{{ toogleIcon ? 'uparrow' : 'downarrow' }}.svg"
          alt=""
        />
      </div>
      <div class="d-flex align-items-center">
        <p *ngIf="istrue" class="px-2 text-danger-color detail-status tab-input-label">
          {{ data?.statusName }}
        </p>
        <div class="d-flex align-items-center mx-3">
          <i
            *ngIf="data?.priorityName == 'High'"
            class="fa fa-circle pe-2 orange-circle"
          ></i>
          <i
            *ngIf="data?.priorityName == 'Critical'"
            class="fa fa-circle pe-2 red-circle"
          ></i>
          <i
            *ngIf="data?.priorityName == 'Low'"
            class="fa fa-circle pe-2 blue-circle"
          ></i>
          <i
            *ngIf="data?.priorityName == 'Standard'"
            class="fa fa-circle pe-2 yellow-circle"
          ></i>
          <span class="text-info-color primary-text">{{ data?.priorityName }}</span>
        </div>
        <img
          *ngIf="istrue && data?.statusName === 'Open'"
          class="m-l-5"
          height="15"
          width="15"
          src="./assets/SVGIcons/grey-circle.svg"
         (click)="chageBgcolor == true ?'': markAsComplete(data?.id)"
          alt=""
        />
        <img
          *ngIf="istrue && data?.statusName === 'Closed'"
          class="m-l-5"
          height="15"
          width="15"
          src="./assets/SVGIcons/circleTick.svg"
          alt=""
        />
        <img
          *ngIf="istrue && data?.statusName === 'Cancelled'"
          class="m-l-5"
          height="15"
          width="15"
          src="./assets/SVGIcons/disabled-circle-tick.svg"
          alt=""
        />
        <p *ngIf="!istrue" class="font-12 text-secondary">
          {{ data?.dueDateInFormat }}
        </p>
      </div>
    </div>
    <div class="m-l-10 m-t-5  text-truncate font-14" *ngIf="istrue">
      <span class="text-decoration-underline text-semi-primary primary-text" href="" (click)="openContactInfo(data)">{{
        data?.contactName
      }} </span>
      <span *ngIf="data?.contactName" class="text-light-info mx-2">/</span>
      <span class="text-decoration-underline text-semi-primary primary-text" href="" (click)="openCompanyInfo(data)">{{
        data?.companyName
      }}</span>
      <span *ngIf="data?.companyName" class="text-light-info ms-3 me-2">/</span>
      <span class="text-light-info primary-text" href="">{{ data?.salesStageName }}</span>
    </div>
    <div class="m-l-10 m-t-5  text-truncate m-r-10">
      <i class="" *ngIf="hideData">
        <p class="text-truncate descriptionWidth primary-text text-light-info">
          {{ data?.description }}
        </p>
      </i>
    </div>
    <div class="d-flex align-item-center justify-content-between flex-wrap gap-1 m-l-10 m-t-5 m-r-10 text-truncate">
      <div class="d-flex align-item-center ">
        <p *ngIf="!istrue" class="text-decoration-underline text-semi-primary primary-text">
          {{ data?.contactName }}
        </p>
   <ng-container *ngFor="let item of iconMappings">
    <app-svg *ngIf="istrue && data?.typeName === item.type" class="m-r-5 d-flex align-items-center justify-content-center" [iconType]="item.icon"></app-svg>
   </ng-container>
        <p *ngIf="istrue" class="font-12 text-light-info d-flex align-items-center justify-content-center">{{ data?.typeName }}</p>
      </div>
      <div class="d-flex align-items-center">
        <p *ngIf="istrue" class="font-12 text-light-info">
          Assigned: {{ data?.assignedUserName }}
        </p>
      </div>
      <div class="d-flex align-items-center">
        <i
          *ngIf="istrue && data?.statusName == 'Open'"
          class="line-height"
          [ngClass]="{
            'text-red-color': data?.aging?.toLowerCase().includes('past due'),
            'text-light-info': !data?.aging?.toLowerCase().includes('past due')
          }"
          >{{ data?.aging }}</i>
          <i
          *ngIf="istrue && data?.statusName == 'Closed'"
          class="line-height"
          [ngClass]="{
            'text-red-color': data?.aging?.toLowerCase().includes('past due'),
            'text-light-info': !data?.aging?.toLowerCase().includes('past due')
          }"
          >{{ data?.aging }}</i>
          <i
          *ngIf="istrue && data?.statusName == 'Cancelled'"
          class="line-height"
          [ngClass]="{
            'text-red-color': data?.aging?.toLowerCase().includes('past due'),
            'text-light-info': !data?.aging?.toLowerCase().includes('past due')
          }"
          >{{ data?.aging }}</i>

      </div>
      <div class="d-flex align-items-center">
        <p
          *ngIf="istrue && currentTab !== 'activityManager'"
          class="line-height  fst-italic text-secondary"
        >
          {{ data?.dueDateInFormat }}
        </p>
        <p
          *ngIf="currentTab == 'activityManager'"
          (click)="datePicker($event,data.id)"
          class="line-height text-secondary fst-italic hand"
        >
          {{ data?.dueDateInFormat }}
        </p>

        <p *ngIf="!istrue" class="font-12 text-info-color">
          Completed by {{ data?.completedBy }}
        </p>
      </div>
    </div>
    <div class="tooltip-container">
  
     <div *ngIf="data.isShowPopup" class="custom-tooltip">
        <div
          class="with-arrow text-center datepicker bg-light-color mx-xl-3 ms-md-5 me-md-3 m-b-10 px-3 py-2"
        >
          <span class="font-12 text-light-info">Snooze</span>
          <div class="d-flex justify-content-center align-item-center mt-1 mb-2">
            <span
              class="font-12 hand text-gray text-nowrap"
              (click)="addUpdateSnooz(1)"
              >24 Hours</span
            >
            <div class="vr"></div>
            <span
              class="font-12 hand text-gray text-nowrap"
              (click)="addUpdateSnooz(2)"
              >48 Hours</span
            >
            <div class="vr"></div>
            <span
              class="font-12 hand text-gray text-nowrap"
              (click)="addUpdateSnooz(3)"
              >1 Week</span
            >
          </div>
          <hr />
          <div class="my-2">
            <span class="font-12 text-light-info">Change Due Date</span>
            <form
              class="theme-form needs-validation novalidate"
              #f="ngForm"
              novalidate
            >
              <div class="mt-2 datepicker-label orderDetail detail">
             <app-date-picker
                [time]="false"
                [inputLabel]="'Date'"
                [inputValue]="selectedDate"
                (inputValueEmit)="changeDateExpiration($event);onClick()"
                [adjustPopupPosition]="'bottom-right'"
              ></app-date-picker> 
              <!-- <app-single-date-select-picker
              (changeDateExpiration)="changeDateExpirations($event)"
              (clearDate)="clear(f)"
              ></app-single-date-select-picker>  -->
              </div>
              <div class="mt-3 tooltipTimePicker">
                <app-ngb-timepicker
                [label]="'Time'"
                [id]="'time'"
                [name]="'time'"
                [selectedTime]="selectedTimeValue"
                [ngbTimePickerValue]="ngbTimePickerValue"
                (timeChange)="selectedTimeValue = $event;changeTimeExpiration($event)"
              ></app-ngb-timepicker>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


